// extracted by mini-css-extract-plugin
export var typingIndicator = "_my-0";